import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CheckoutFormSchema } from '../schema';
import type { IPaymentMethod, IShippingMethod } from '../types';
import Method from './Method';

interface IProps {
  shippingMethods: IShippingMethod[];
  paymentMethods: IPaymentMethod[];
}

export default function StepMethods({ paymentMethods, shippingMethods }: IProps) {
  const { t } = useTranslation();

  const { control } = useFormContext<CheckoutFormSchema>();

  const shippingId = useWatch({ control, name: 'shippingMethodId' });
  const paymentId = useWatch({ control, name: 'paymentMethodId' });
  const isCompany = useWatch({ control, name: 'customer.isCompany' });

  const allowedShippingMethods = useMemo(
    () =>
      shippingMethods
        .filter(sm => (isCompany ? sm.companyPayments : sm.citizenPayments).length > 0)
        .map(sm => sm.id),
    [shippingMethods, isCompany]
  );
  const allowedPayments = useMemo(() => {
    const shippingMethod = shippingMethods.find(t => t.id === shippingId);
    const paymentIds = isCompany
      ? shippingMethod?.companyPayments
      : shippingMethod?.citizenPayments;
    return paymentIds ?? [];
  }, [shippingMethods, shippingId, isCompany]);

  // Ak bude potrebne, aby sa odznacili podmienky, pri nastaveni/ostaveni dodacej adresy
  // useEffect(() => {
  //   setValue('shippingMethodId', '');
  //   setValue('paymentMethodId', '');
  // }, [isDifferentShipping, setValue]);

  return (
    <div className={'max-w-md w-full block'}>
      <div className="grid gap-y-4">
        <div>
          <h4>{t('ShippingMethod')}</h4>

          <div className="form-fields">
            {shippingMethods.map(sm => (
              <Method
                key={sm.id}
                {...sm}
                isAllowed={allowedShippingMethods.includes(sm.id)}
                selectedMethodId={shippingId}
              />
            ))}
          </div>
        </div>

        <div>
          <h4>{t('PaymentMethod')}</h4>

          <div className="form-fields">
            {paymentMethods.map(pm => (
              <Method
                key={pm.id}
                {...pm}
                isAllowed={allowedPayments.includes(pm.id)}
                selectedMethodId={paymentId}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
